/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

import { noopDetector } from '../../NoopDetector';

/**
 * @experimental
 */
export const serviceInstanceIdDetector = noopDetector;
